<template>
  <div>
    <div v-if="forced_server">
      <v-text-field outlined dense hide-details class="mb-3" :label="$t('login.label.server')" disabled
                    :value="forced_server"></v-text-field>
    </div>

    <div v-else>
      <v-combobox
          v-if="servers != null && servers.length > 0"
          required outlined dense hide-details class="mb-3"
          :value="value"
          :items="servers"
          :label="fieldLabel"
          :suffix="fieldSuffix"
          :placeholder="fieldPlaceholder"
          :disabled="disabled"
          @input="$emit('input', $event)"
      >
        <template #item="{ item }">
          <v-list-item-content>{{ item }}</v-list-item-content>
          <v-list-item-action>
            <v-btn icon x-small @click.stop="$emit('remove-server', item)">
              <v-icon x-small>mdi-close</v-icon>
            </v-btn>
          </v-list-item-action>
        </template>
      </v-combobox>

      <v-text-field
          v-else
          required outlined dense hide-details class="mb-3"
          :disabled="disabled"
          :label="fieldLabel"
          :suffix="fieldSuffix"
          :placeholder="fieldPlaceholder"
          type="text"
          :value="value"
          :clearable="true"
          @input="$emit('input', $event)"
          @keyup.enter="$emit('submit')"
      ></v-text-field>
    </div>

  </div>
</template>

<script>
export default {
  name: 'LoginServerField',
  props: {
    value: { type: String, default: null },
    servers: { type: Array, default: () => [] },
    forcedServer: { type: String, default: null },
    serverDomain: { type: String, default: null },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    // kept for template — resolves to forcedServer for backwards-compat slot
    forced_server() { return this.forcedServer; },
    fieldLabel() {
      return this.serverDomain ? 'Company' : this.$t('login.label.server');
    },
    fieldSuffix() {
      return this.serverDomain ? '.' + this.serverDomain : null;
    },
    fieldPlaceholder() {
      return this.serverDomain ? 'your-company' : null;
    },
  },
}
</script>
